export default __webpack_public_path__ + "static/media/02AW4SEP66.1ef2b98a.jpg";